import { CONFIG_QUERY_KEY } from '@modules/config/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type {
  ISettingsUploadLogoSaveResponse,
} from '../types';
import {
  ADMIN_GENERAL_SETTINGS_UPLOAD_LOGO_PERMISSIONS,
  SETTINGS_UPLOAD_LOGO_QUERY_KEY,
  SETTINGS_UPLOAD_LOGO_URL,
} from '../constants';

export default function useSettingsUploadLogoMutation(): ReturnType<
  typeof useContextMutation<ISettingsUploadLogoSaveResponse, Error, FormData>
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<
    ISettingsUploadLogoSaveResponse,
    Error,
    FormData
  >({
    mutationKey: [SETTINGS_UPLOAD_LOGO_QUERY_KEY],
    mutationFn: (payload) => fetchPost<ISettingsUploadLogoSaveResponse>(
      SETTINGS_UPLOAD_LOGO_URL,
      payload,
      {

        permission: ADMIN_GENERAL_SETTINGS_UPLOAD_LOGO_PERMISSIONS.PROJECTSETTINGS_EDIT,
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [SETTINGS_UPLOAD_LOGO_QUERY_KEY] });
      await queryClient.refetchQueries({ queryKey: [CONFIG_QUERY_KEY] });
      displayPresetToast('edited');
    },
  });
}
